import { render, staticRenderFns } from "./CancellationPolicyCategories.vue?vue&type=template&id=5c441e00&scoped=true&"
import script from "./CancellationPolicyCategories.vue?vue&type=script&lang=js&"
export * from "./CancellationPolicyCategories.vue?vue&type=script&lang=js&"
import style0 from "./CancellationPolicyCategories.vue?vue&type=style&index=0&id=5c441e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c441e00",
  null
  
)

export default component.exports